export const formatAddressTargeting = (address) => {
  if (!address) return;

  return {
    suburb: address.suburb,
    postcode: address.postCode || address.postcode,
    state: address.stateCode || address.state,
  };
};

export const formatAddressWithStatusTargeting = (address, propertyStatus) => {
  if (!address) return;

  return {...formatAddressTargeting(address), property_status: propertyStatus};
};

export const isAdDisplayed = (adIframeId) => {
  if (typeof window != 'undefined' && window.document.querySelector(`iframe[id*="${adIframeId}"]`)
      && document.querySelector(`iframe[id*="${adIframeId}"]`).contentDocument) {
    return true;
  }

  return false;
};